function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
/* eslint-disable @typescript-eslint/naming-convention */ import { RliPreHook } from '@rocketlane/rli-internal-sdk';
import { stringify } from 'query-string';
import { ExportStatusType } from 'api/async-export';
import { QueryCombinerType } from 'api/tasks/filter-types';
import { TaskEvents } from 'events/tasks';
import { InitWorkerRequestType, InitWorkerApi } from 'initWorker';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { constructUrl } from 'utils/http-utilts';
import { getSimpleSearchFilterModule } from 'utils/simple-search-filter/module';
import { WithNotStrategicTransformer } from './with-non-strategic-partner';
export { TaskApprovalAPI } from './approval';
// TODO: replace with generic status? ProjectPhaseStatus looks the same
// @abhilashlr @Shajansheriff
export var TaskStatus = /*#__PURE__*/ function(TaskStatus) {
    TaskStatus["ToDo"] = "Todo";
    TaskStatus["InProgress"] = "In progress";
    TaskStatus["Completed"] = "Completed";
    TaskStatus["Blocked"] = "Blocked";
    TaskStatus["Proposed"] = "Proposed";
    TaskStatus["InPlanning"] = "In Planning";
    TaskStatus["ToBeStaffed"] = "To be Staffed";
    TaskStatus["Cancelled"] = "Cancelled";
    return TaskStatus;
}({});
export var TaskCardPosition = /*#__PURE__*/ function(TaskCardPosition) {
    TaskCardPosition["Top"] = "top";
    TaskCardPosition["Bottom"] = "bottom";
    return TaskCardPosition;
}({});
export var TaskType = /*#__PURE__*/ function(TaskType) {
    TaskType["Task"] = "TASK";
    TaskType["Milestone"] = "MILESTONE";
    return TaskType;
}({})// TODO:: This is just sample implementation, we can configure once we have use case.
;
export var TaskEffortSetting = /*#__PURE__*/ function(TaskEffortSetting) {
    TaskEffortSetting["Equal"] = "EQUAL_SPLIT";
    TaskEffortSetting["Custom"] = "UNEQUAL_SPLIT";
    return TaskEffortSetting;
}({});
export var TaskSourceType = /*#__PURE__*/ function(TaskSourceType) {
    TaskSourceType["Document"] = "DOCUMENT";
    TaskSourceType["DocumentSection"] = "DOCUMENT_SECTION";
    TaskSourceType["SpaceTab"] = "SPACE_TAB";
    TaskSourceType["Default"] = "DEFAULT";
    TaskSourceType["Template"] = "TEMPLATE";
    return TaskSourceType;
}({});
export var TaskStatusGroup = /*#__PURE__*/ function(TaskStatusGroup) {
    TaskStatusGroup[TaskStatusGroup["Todo"] = 1] = "Todo";
    TaskStatusGroup[TaskStatusGroup["InProgress"] = 2] = "InProgress";
    TaskStatusGroup[TaskStatusGroup["Completed"] = 3] = "Completed";
    TaskStatusGroup[TaskStatusGroup["Blocked"] = 4] = "Blocked";
    return TaskStatusGroup;
}({});
export var StatusGroup = /*#__PURE__*/ function(StatusGroup) {
    StatusGroup[StatusGroup["Todo"] = 1] = "Todo";
    StatusGroup[StatusGroup["InProgress"] = 2] = "InProgress";
    StatusGroup[StatusGroup["Completed"] = 3] = "Completed";
    StatusGroup[StatusGroup["Blocked"] = 4] = "Blocked";
    StatusGroup[StatusGroup["Proposed"] = 5] = "Proposed";
    StatusGroup[StatusGroup["InPlanning"] = 6] = "InPlanning";
    StatusGroup[StatusGroup["ToBeStaffed"] = 7] = "ToBeStaffed";
    StatusGroup[StatusGroup["Cancelled"] = 8] = "Cancelled";
    return StatusGroup;
}({});
export var ProjectStatusGroup = /*#__PURE__*/ function(ProjectStatusGroup) {
    ProjectStatusGroup[ProjectStatusGroup["Todo"] = 5] = "Todo";
    ProjectStatusGroup[ProjectStatusGroup["InProgress"] = 2] = "InProgress";
    ProjectStatusGroup[ProjectStatusGroup["Completed"] = 3] = "Completed";
    ProjectStatusGroup[ProjectStatusGroup["On hold"] = 4] = "On hold";
    ProjectStatusGroup[ProjectStatusGroup["Cancelled"] = 8] = "Cancelled";
    return ProjectStatusGroup;
}({});
export var BudgetStatusGroup = /*#__PURE__*/ function(BudgetStatusGroup) {
    BudgetStatusGroup[BudgetStatusGroup["Proposed"] = 1] = "Proposed";
    BudgetStatusGroup[BudgetStatusGroup["Active"] = 2] = "Active";
    BudgetStatusGroup[BudgetStatusGroup["Completed"] = 3] = "Completed";
    return BudgetStatusGroup;
}({});
export var FieldClass = /*#__PURE__*/ function(FieldClass) {
    FieldClass["Native"] = "NATIVE";
    FieldClass["Custom"] = "CUSTOM";
    return FieldClass;
}({});
export var CustomFieldValueSourceType = /*#__PURE__*/ function(CustomFieldValueSourceType) {
    CustomFieldValueSourceType["Manual"] = "MANUAL";
    CustomFieldValueSourceType["Inherited"] = "INHERITED";
    return CustomFieldValueSourceType;
}({});
var FormulaType = /*#__PURE__*/ function(FormulaType) {
    FormulaType["Simple"] = "SIMPLE";
    FormulaType["Conditional"] = "CONDITIONAL";
    return FormulaType;
}(FormulaType || {});
class TasksHttpClient extends WithNotStrategicTransformer {
    async getTask(projectID, taskID) {
        return this.getWithTransformer(`/projects/${projectID}/tasks/${taskID}`);
    }
    async updateTask(projectID, taskID, data, isSync, actor) {
        const config = {};
        if (actor) {
            config.headers = {
                'X-Actor': JSON.stringify(actor)
            };
        }
        return this.putWithTransformer(`/projects/${projectID}/tasks/${taskID}${isSync ? `?isSync=${true}` : ''}`, data, config);
    }
    async updateTaskMini(projectID, taskID, data, isSync) {
        const config = {};
        return this.putWithTransformer(`/projects/${projectID}/tasks/${taskID}/mini${isSync ? `?isSync=${true}` : ''}`, data, config);
    }
    async bulkUpdateTask(data, options) {
        return this.put(`/bulk/tasks?isFromAllTasks=${options.isAllTask}`, data);
    }
    async bulkUpdateAllTasks(data, options) {
        const queryParams = [
            `projectId=${options.projectId}`
        ];
        if (options.applyToSubtask === false) {
            queryParams.push('parentTask.isEmpty=true');
        }
        const finalUrl = `/bulk/tasks?${queryParams.join('&')}`;
        return this.put(finalUrl, data);
    }
    async createTask(projectID, data) {
        return this.postWithTransformer(`/projects/${projectID}/tasks/`, data);
    }
    async createTaskWithForm({ projectId, data }) {
        return this.postWithTransformer(`/projects/${projectId}/tasks/`, data);
    }
    async duplicateTask(projectId, data) {
        return this.post(`/projects/${projectId}/tasks/duplicate`, data);
    }
    async addTaskTemplatesToProject(projectID, data) {
        return this.postWithTransformer(`/projects/${projectID}/tasks/add-from-templates`, data);
    }
    async createTaskWithRequestId([, projectId], data, requestId) {
        return this.postWithTransformer(`/projects/${projectId}/tasks/`, data, {
            headers: {
                'X-Request-Id': requestId
            }
        });
    }
    async getTaskFields() {
        let data;
        try {
            data = await InitWorkerApi.getData(InitWorkerRequestType.TaskFields);
        } catch (unused) {
            data = await this.get('/tasks/fields');
        }
        return data;
    }
    async deleteTask(projectID, taskID, actor) {
        const config = {};
        if (actor) {
            config.headers = {
                'X-Actor': JSON.stringify(actor)
            };
        }
        return this.delete(`/projects/${projectID}/tasks/${taskID}/`, config);
    }
    async createDependentTask(projectID, taskID, data, isSync) {
        return this.postWithTransformer(`/projects/${projectID}/tasks/${taskID}/add-dependency${isSync ? `?isSync=${true}` : ''}`, data);
    }
    async removeDependentTask(projectID, taskID, data) {
        return this.post(`/projects/${projectID}/tasks/${taskID}/remove-dependency`, data);
    }
    async updateDependentTasks(taskId, data, isSync) {
        return this.postWithTransformer(`/tasks/${taskId}/update-dependent-tasks${isSync ? `?isSync=${true}` : ''}`, data);
    }
    async deleteTaskAttachment(attachmentID) {
        return this.delete(`attachments/${attachmentID}/`);
    }
    async addRating(taskID, data) {
        return this.post(`/tasks/${taskID}/add-rating`, data);
    }
    async updatePrivacy(taskID, data) {
        return this.postWithTransformer(`/tasks/${taskID}/update-privacy`, data);
    }
    async addMultipleSubtasks(parentTaskId, data) {
        return this.post(`tasks/${parentTaskId}/create-bulk-subtasks`, data);
    }
    async addMultipleTasks(parentTaskId, data) {
        return this.post(`projects/${parentTaskId}/tasks/bulk-create`, data);
    }
    async logFilters(filter) {
        const { ApiFilter } = await getSimpleSearchFilterModule();
        let url = '/tasks/searchlightV1?';
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        const filterAsString = ApiFilter.toQueryStringFormat(filter.criteria);
        if (filter.criteria.length) {
            url += `${filterAsString}&match=${filter.type}&`;
        }
        this.get(url);
    }
    async removeAsSubtask(taskId) {
        return this.put(`/tasks/remove-as-subtask/${taskId}`);
    }
    async getBulkTaskDetails(taskIds) {
        return this.post('/tasks/search/getTaskByIds', {
            taskIds
        }).then((tasks)=>{
            if (!Array.isArray(tasks)) {
                throw new Error('Invalid response: tasks is not an array');
            }
            return tasks.map((task)=>{
                return task && task.fieldsAccessMeta != null ? {
                    ...task,
                    fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                } : task;
            });
        });
    }
    async getTaskFieldValues(taskIds) {
        return this.post('/tasks/fields/unique-values', taskIds);
    }
    async getSubtaskCount(projectId) {
        const url = constructUrl({
            baseURL: '/tasks/searchlightV1/subtask-count',
            params: {
                projectId
            }
        });
        return this.get(url);
    }
    async getTaskDetailsDefaultFields({ projectId, taskId }) {
        return this.getWithTransformer(`/projects/${projectId}/tasks/${taskId}/get-default-fields`);
    }
    async getTaskDetailsAdditionalFields({ projectId, taskId }) {
        return this.getWithTransformer(`/projects/${projectId}/tasks/${taskId}/get-additional-fields`);
    }
    constructor(...args){
        super(...args), _define_property(this, "getTaskList", async (projectId, config)=>this.getWithTransformer(`/projects/${projectId}/tasks`, config)), /** Light task list for the gantt timeline; heavy fields hydrate per row. */ _define_property(this, "getGanttLightTaskList", async (projectId)=>this.getWithTransformer(`/projects/${projectId}/tasks/gantt-light`)), /** Full-fidelity hydration for a bounded id window (max 200 per call). */ _define_property(this, "hydrateGanttTasks", async (projectId, taskIds)=>this.postWithTransformer(`/projects/${projectId}/tasks/hydrate`, {
                taskIds
            })), _define_property(this, "getAllTasksLight", async ()=>this.getWithTransformer('/tasks/light')), _define_property(this, "searchTasks", async (filter)=>{
            const { ApiFilter } = await getSimpleSearchFilterModule();
            return this.getWithTransformer(`/tasks/search?${ApiFilter.toQueryStringFormat(// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            filter.criteria)}&${stringify({
                match: filter.criteria.length ? filter.type : null
            }, {
                skipNull: true
            })}`);
        }), _define_property(this, "getTasksAndMilestonesForProjects", async (projectId, isMilestone = false)=>{
            return this.getWithTransformer(`/tasks/search?project.value=${projectId}&match=all${isMilestone ? '&type.value=MILESTONE' : ''}`);
        }), _define_property(this, "getPaginatedRecentlyAssignedTaskList", async ({ startRow = 0, endRow = 100, noOfDays = 2, filter, filterType, sort = 'asc' })=>{
            const { ApiGroupFilter } = await getSimpleSearchFilterModule();
            const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
            let url = `home/recentlyAssigned?noOfDays=${noOfDays}&sort=${sort}&offset=${startRow}&limit=${endRow - startRow}`;
            if (filter.length) {
                url += `&${filterAsString}&match=${filterType}`;
            }
            return this.get(url);
        }), _define_property(this, "getPaginatedTaskList", async ({ startRow, endRow, filter, sort, filterType, searchValue })=>{
            const { ApiGroupFilter } = await getSimpleSearchFilterModule();
            let url = '/tasks/searchlightV1?';
            const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
            if (searchValue) {
                url += `${searchValue}&`;
            }
            if (filter.length) {
                url += `${filterAsString}&match=${filterType}&`;
            }
            if (sort) {
                url += `sort=${sort}`;
            }
            url += `&offset=${startRow}&limit=${endRow - startRow}`;
            return this.get(url).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "postFilteredTasks", async (filter, startRow, endRow, sort, filterType, searchValue)=>{
            let url = '/tasks/searchlightV1?';
            if (searchValue) {
                url += `${searchValue}&`;
            }
            if (sort) {
                url += `sort=${sort}`;
            }
            url += `&offset=${startRow}&limit=${endRow - startRow}`;
            return this.post(url, {
                filter
            }).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "getPaginatedTaskListWithProject", async ({ startRow, endRow, filter, sort, epicId, filterType, projectId, isEverything, groupBy, searchValue })=>{
            const { ApiGroupFilter } = await getSimpleSearchFilterModule();
            const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
            const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
            const filterString = filter.length ? filterAsString : undefined;
            const url = constructUrl({
                baseURL: '/tasks/searchlightV1',
                params: {
                    projectId,
                    match: validFilterType,
                    sort,
                    epicId,
                    offset: startRow,
                    limit: endRow - startRow,
                    groupBy,
                    everything: isEverything ? true : undefined
                },
                paramsToAddWithoutKeys: [
                    filterString,
                    searchValue
                ]
            });
            return this.get(url).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "postPaginatedTaskListCount", async ({ filter, projectId, isEverything, applyToSubtask })=>{
            const url = constructUrl({
                baseURL: '/tasks/searchlightV1/count',
                params: {
                    projectId,
                    everything: isEverything ? true : undefined,
                    ...!applyToSubtask ? {
                        'parentTask.isEmpty': true
                    } : {}
                }
            });
            return this.post(url, {
                filter
            });
        }), _define_property(this, "postPaginatedTaskListWithProject", async ({ startRow, endRow, filter, sort, filterType, projectId, isEverything, searchValue, applyToSubtask })=>{
            const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
            const params = {
                projectId,
                match: validFilterType,
                sort,
                offset: startRow,
                limit: endRow - startRow,
                everything: isEverything ? true : undefined
            };
            if (!applyToSubtask) {
                params['parentTask.isEmpty'] = true;
            }
            const url = constructUrl({
                baseURL: '/tasks/searchlightV1',
                params,
                paramsToAddWithoutKeys: [
                    searchValue
                ]
            });
            return this.post(url, {
                filter
            }).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "postPaginatedTaskListWithSubtasks", async ({ startRow, endRow, filter, sort, filterType, projectId, isEverything, searchValue })=>{
            const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
            const url = constructUrl({
                baseURL: '/tasks/searchlightV1',
                params: {
                    projectId,
                    match: validFilterType,
                    sort,
                    offset: startRow,
                    limit: endRow - startRow,
                    everything: isEverything ? true : undefined
                },
                paramsToAddWithoutKeys: [
                    searchValue
                ]
            });
            return this.post(url, {
                filter
            }).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "getAllTaskListWithProject", async ({ filter, filterType, searchValue })=>{
            const { ApiGroupFilter } = await getSimpleSearchFilterModule();
            const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
            const validFilterType = Object.values(QueryCombinerType).includes(filterType) ? filterType : QueryCombinerType.All;
            const filterString = filter.length ? filterAsString : undefined;
            const match = filter.length ? validFilterType : undefined;
            const url = constructUrl({
                baseURL: '/tasks/searchlightV1',
                params: {
                    match
                },
                paramsToAddWithoutKeys: [
                    filterString,
                    searchValue
                ]
            });
            return this.get(url).then((response)=>({
                    ...response,
                    data: response.data.map((task)=>task.fieldsAccessMeta != null ? {
                            ...task,
                            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                        } : task)
                }));
        }), _define_property(this, "getSubTasks", (taskId)=>{
            return this.get(`/tasks/${taskId}/get-subtasks`).then((tasks)=>tasks.map((task)=>task.fieldsAccessMeta != null ? {
                        ...task,
                        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta)
                    } : task));
        }), _define_property(this, "searchTasksForTimesheet", async (fromDateInMillisecond, toDateInMillisecond, projectId)=>{
            return this.get(`/tasks/timesheet?${stringify({
                fromDate: fromDateInMillisecond.valueOf(),
                toDate: toDateInMillisecond.valueOf(),
                projectId
            })}`);
        }), _define_property(this, "getPaginatedTaskListForDashbaord", async ({ dashboardFilter, widgetFilter, startRow, endRow, sort, widgetId })=>{
            let url = `/widgets/${widgetId}/drill-down-items?`;
            if (sort) {
                url += `sort=${sort}`;
            }
            url += `&offset=${startRow}&limit=${endRow - startRow}`;
            return this.post(url, {
                drillDownFilter: widgetFilter,
                dashboardFilter
            });
        }), _define_property(this, "updateSubTaskOrder", (taskId, payload)=>{
            return this.put(`/tasks/${taskId}/update-subtask-order`, payload);
        }), _define_property(this, "updatePhase", (taskId, payload)=>{
            return this.putWithTransformer(`/tasks/${taskId}/update-phase`, payload);
        }), _define_property(this, "exportAsCSVAsyncForGroupType", async ({ filters, match, columnOrder, projectId })=>{
            const { ApiFilter, ApiGroupFilter } = await getSimpleSearchFilterModule();
            const filterString = ApiGroupFilter.toQueryStringFormatForGroups(filters);
            const filterObject = ApiFilter.convertQueryStringToObject(filterString);
            let filterBy = {
                match,
                ...filterObject
            };
            if (projectId) {
                filterBy = {
                    ...filterBy,
                    projectId
                };
            }
            const request = {
                filterBy,
                columnOrder
            };
            const data = {
                statusType: ExportStatusType.TaskExport,
                statusMeta: {
                    request
                }
            };
            return this.post('async/status', data);
        }), _define_property(this, "exportAsCSVAsyncForGroupTypeV2", ({ filters, match, columnOrder, projectId })=>{
            match = filters.match;
            const filterBy = {
                match
            };
            if (projectId) {
                filterBy.projectId = projectId;
            }
            const request = {
                filterBy,
                columnOrder
            };
            const data = {
                statusType: ExportStatusType.TaskExport,
                statusMeta: {
                    filter: filters,
                    request
                }
            };
            return this.post('async/status', data);
        }), _define_property(this, "exportAsCSVAsyncForNonGroup", async ({ filters, match, columnOrder, projectId })=>{
            const { ApiFilter } = await getSimpleSearchFilterModule();
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            const filterString = ApiFilter.toQueryStringFormat(filters);
            const filterObject = ApiFilter.convertQueryStringToObject(filterString);
            let filterBy = {
                match,
                ...filterObject
            };
            if (projectId) {
                filterBy = {
                    ...filterBy,
                    projectId
                };
            }
            const request = {
                filterBy,
                columnOrder
            };
            const data = {
                statusType: ExportStatusType.TaskExport,
                statusMeta: {
                    request
                }
            };
            return this.post('async/status', data);
        }), _define_property(this, "exportAsCSVAsyncForNonGroupV2", ({ filters, match, columnOrder, projectId, applyToSubtask })=>{
            var _ref, _ref1, _ref2;
            var _filters_nativeFields, _filters_customFields, _filters_nestedFilter;
            const filterBy = {
                match
            };
            if (projectId) {
                filterBy.projectId = projectId;
            }
            if (!applyToSubtask && (((_ref = (_filters_nativeFields = filters.nativeFields) === null || _filters_nativeFields === void 0 ? void 0 : _filters_nativeFields.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_filters_customFields = filters.customFields) === null || _filters_customFields === void 0 ? void 0 : _filters_customFields.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0 || ((_ref2 = (_filters_nestedFilter = filters.nestedFilter) === null || _filters_nestedFilter === void 0 ? void 0 : _filters_nestedFilter.length) !== null && _ref2 !== void 0 ? _ref2 : 0) > 0)) {
                filterBy['parentTask.isEmpty'] = 'true';
            }
            const request = {
                filterBy,
                columnOrder
            };
            const data = {
                statusType: ExportStatusType.TaskExport,
                statusMeta: {
                    filter: filters,
                    request
                }
            };
            return this.post('async/status', data);
        });
    }
}
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskUpdate,
        dataGetter: (projectId, taskId, data)=>({
                taskId,
                projectId,
                task: data
            })
    })
], TasksHttpClient.prototype, "updateTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskUpdate,
        dataGetter: (projectId, taskId, data)=>({
                taskId,
                projectId,
                task: data
            })
    })
], TasksHttpClient.prototype, "updateTaskMini", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.BulkTaskUpdate,
        dataGetter: (data, options)=>({
                data,
                options
            })
    })
], TasksHttpClient.prototype, "bulkUpdateTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.BulkTaskUpdate,
        dataGetter: (data, options)=>({
                data,
                options
            })
    })
], TasksHttpClient.prototype, "bulkUpdateAllTasks", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskCreate,
        dataGetter: (projectId, data)=>({
                projectId,
                task: data
            })
    })
], TasksHttpClient.prototype, "createTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskCreate,
        dataGetter: ({ projectId, data })=>({
                projectId,
                task: data
            })
    })
], TasksHttpClient.prototype, "createTaskWithForm", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskCreate,
        dataGetter: (projectId, data)=>({
                projectId,
                data
            })
    })
], TasksHttpClient.prototype, "duplicateTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskCreate,
        dataGetter: (projectId, data)=>({
                projectId,
                data
            })
    })
], TasksHttpClient.prototype, "addTaskTemplatesToProject", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskCreate,
        dataGetter: ([, projectId], data)=>({
                projectId,
                data
            })
    })
], TasksHttpClient.prototype, "createTaskWithRequestId", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskDelete,
        dataGetter: (projectId, taskId)=>({
                projectId,
                taskId
            })
    })
], TasksHttpClient.prototype, "deleteTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.DependentTaskCreate,
        dataGetter: (projectId, taskId, data)=>({
                projectId,
                taskId,
                data
            })
    })
], TasksHttpClient.prototype, "createDependentTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.DependentTaskDelete,
        dataGetter: (projectId, taskId, data)=>({
                projectId,
                taskId,
                data
            })
    })
], TasksHttpClient.prototype, "removeDependentTask", null);
_ts_decorate([
    RliPreHook({
        event: TaskEvents.TaskUpdate,
        dataGetter: (taskId, data)=>({
                taskId,
                data
            })
    })
], TasksHttpClient.prototype, "updatePrivacy", null);
export const TaskAPI = new TasksHttpClient();
